<template>
  <!-- 修改用户信息弹框 -->
  <!-- 目前只支持卡号、用户名、手机号 -->
  <div>
    <el-dialog
      title="修改角色权限"
      :visible.sync="userEditVisible"
      width="30%"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="增加权限" name="first">
          <el-tree
            :data="data"
            show-checkbox
            node-key="privilegeName"
            :props="defaultProps"
            :default-checked-keys="privilegeName"
            ref="tree"
          >
          </el-tree>
          <div class="footer">
            <el-button type="primary" @click="onSubmit">修改</el-button>
            <el-button @click="handleClose">取消</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="删除权限" name="second">
          <el-tree
            :data="treeData"
            show-checkbox
            node-key="privilegeName"
            :props="defaultProps1"
            ref="trees"
          >
          </el-tree>
          <div class="footer">
            <el-button type="primary" @click="onSubmits">删除</el-button>
            <el-button @click="handleClose">取消</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- <el-tree
        :data="data"
        show-checkbox
        node-key="privilegeName"
        :props="defaultProps"
        ref="tree"
      >
      </el-tree> -->
      <!-- <div slot="footer">
        <el-button type="primary" @click="onSubmit">修改</el-button>
        <el-button @click="userEditVisible = false">取消</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/api/factory/user/list";
export default {
  data() {
    return {
      activeName: "first",
      userEditVisible: false,
      data: [],
      treeData: [],
      workerInfo: {},
      privilegeName: [],
      defaultProps: {
        children: "children",
        label: "privilegeDescription",
      },
      defaultProps1: {
        children: "children",
        label: "privilegeDescription",
      },
    };
  },
  mounted() {},
  methods: {
    // 外部调用，展示修改用户信息的弹框
    show(workerInfo) {
      this.activeName = "first";
      this.privilegeName = [];
      this.userEditVisible = true;
      this.workerInfo = workerInfo;

      api.getRoleList().then((res) => {
        console.log(res);
        this.data = res.data;
      });

      if (this.workerInfo.privileges.length > 0) {
        this.workerInfo.privileges.forEach((item) => {
          this.privilegeName.push(item.privilegeName);
        });
      }
    },
    handleClose() {
      this.userEditVisible = false;
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.index == 1) {
        this.treeData = this.$refs.tree.getCheckedNodes();
        console.log(this.treeData);
        this.treeData.forEach((item1) => {
          // 查找第二个数组中与当前元素相同ID的元素
          let matchingElement = this.workerInfo.privileges.find(
            (item2) => item2.privilegeName === item1.privilegeName
          );
          // 如果找到匹配的元素，则将其value添加到第一个数组的相应元素中
          if (matchingElement) {
            item1.id = matchingElement.id;
          }
        });
        console.log("111", this.treeData);
      }
    },
    // 点击修改按钮
    onSubmit() {
      const checkedKeys = this.$refs.tree.getCheckedKeys();
      console.log(checkedKeys);

      // 构建接口所需的参数结构
      const requestBody = {
        privileges: checkedKeys.map((privilegeName) => ({
          id: null,
          isDeleted: false,
          privilegeName,
        })),
        roleId: this.workerInfo.id,
      };

      // 调用 API 更新用户的角色权限
      api
        .updatePrivilege(requestBody)
        .then((res) => {
          console.log(res);
          // 更新成功的处理逻辑，例如关闭弹框
          this.$emit("update");
          this.userEditVisible = false;
          this.$message.success("增加权限成功！");
        })
        .catch((error) => {
          // 更新失败的处理逻辑，例如显示错误信息
          console.error("Failed to update user role permissions:", error);
          this.$message.error("增加权限失败，请重试！");
        });
    },
    onSubmits() {
      const checkedKeys = this.$refs.trees.getCheckedNodes();
      console.log(checkedKeys);

      // 构建接口所需的参数结构
      const requestBody = {
        privileges: checkedKeys.map((item) => ({
          id: item.id,
          isDeleted: true,
          privilegeName: item.privilegeName,
        })),
        roleId: this.workerInfo.id,
      };

      // 调用 API 更新用户的角色权限
      api
        .updatePrivilege(requestBody)
        .then((res) => {
          console.log(res);
          // 更新成功的处理逻辑，例如关闭弹框
          this.$emit("update");
          this.userEditVisible = false;
          this.$message.success("删除权限成功！");
        })
        .catch((error) => {
          // 更新失败的处理逻辑，例如显示错误信息
          console.error("Failed to update user role permissions:", error);
          this.$message.error("删除权限失败，请重试！");
        });
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  float: right;
  margin-top: 10px;
}
::v-deep .el-dialog__body {
  padding: 10px 20px !important;
}
</style>
